import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";
import OneStaff from "./OneStaff";
import clientsImage from "../assets/clients.jpg";
import teamImage from "../assets/team.jpg";
import bg from "../assets/bg.jpg";
import dp from "../assets/dp.jpg";

export default function PartnersBanner() {
  const appContext = useContext(AppContext);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    setReady(true);
  }, []);

  if (!ready) {
    return (
      <div className="container mSupportLoading">
        {getInlineLoader()}
      </div>
    );
  }

  return (
    <div 
		className="MainBodySection py-5"
		style={{
			backgroundImage: `url(${bg})`,
			backgroundAttachment: "fixed",
			backgroundSize: "cover",
			backgroundPosition: "center",
		}}
	>
      <div className="container">
        <div className="row justify-content-center">

          {/* Section Header */}
          <div className="col-md-12 text-center mb-4">
            <h6 className="main-section-title">TEAM PROFILE</h6>
            <p className="text-dim" style={{ maxWidth: "850px", margin: "0 auto" }}>
              Our team consists of highly skilled professionals with strong industry
              experience, technical expertise, and a shared commitment to delivering
              quality, integrity, and measurable results for our clients.
            </p>
          </div>

          {/* Team Card */}
          <div className="col-md-12 col-lg-8">
            <div className="bg-white p-4 rounded-4 mShadow2">

              <div className="row align-items-center">
                {/* Image */}
                <div className="col-md-6 mb-3 mb-md-0">
                  <img
                    src={teamImage}
                    alt="Our Team"
                    style={{
                      width: "100%",
                      borderRadius: "12px",
                      objectFit: "cover",
                    }}
                  />
                </div>

                {/* Description */}
                <div className="col-md-6">
                  <h5 className="font-semi-bold mb-3">Dedicated. Experienced. Reliable.</h5>
                  <p className="text-dim">
                    Our multidisciplinary team brings together professionals from
                    finance, management, consulting, and operations. We work collaboratively
                    to understand client needs, apply strategic thinking, and deliver
                    sustainable solutions that drive long-term value.
                  </p>
                  <p className="text-dim mb-0">
                    Continuous learning, ethical practice, and accountability define
                    how we operate and how we serve every client.
                  </p>
                </div>
              </div>

            </div>
          </div>

		  <div className="col-md-12">
				{/* Team Profile */}
			<div className="col-md-12 mt-5 text-center">
				<p className="text-dim pb-4" style={{ maxWidth: 900, margin: "0 auto" }}>
				Our team is made up of experienced professionals who are passionate
				about construction and dedicated to helping businesses succeed.
				</p>
			</div>

			{/* Team Members */}
			<div className="row g-3 justify-content-center mb-5">
				<OneStaff passport={dp} name="Oscar E. Msechu" description="Managing Director" />
				<OneStaff passport={dp} name="Gabriel J. Silayo" description="Director" />
				<OneStaff passport={dp} name="Ally R. Shangirwa" description="Director" />
				<OneStaff passport={dp} name="Oliver Mosha" description="HR & Accounts Personnel" />
			</div>
		</div>

		<div className="col-md-12 text-center mb-4">
            <h6 className="main-section-title">OUR CLIENTS</h6>
            <p className="text-dim" style={{ maxWidth: 850, margin: "0 auto" }}>
              We have successfully delivered services to a diverse range of
              public and private sector clients, building long-term partnerships
              founded on trust and performance.
            </p>
          </div>

          <div className="col-md-10 col-lg-8">
            <div className="bg-white p-4 rounded-4 mShadow2">
              <div className="row align-items-center">
                <div className="col-md-12 mb-3 mb-md-0">
                  <img
                    src={clientsImage}
                    alt="Our Clients"
                    style={{ width: "100%", borderRadius: "12px" }}
                  />
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}
